import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { useHandleMutationCompleted } from '../../components/contributions/hooks/useHandleMutationCompleted';
import { EP_QUESTION_DETAILS_QUERY } from '../question/getQuestionDetails';
const UPDATE_EF_MUTATION = gql `
  mutation EP_UpdateEF($questionID: String!, $data: EPEFInput!) {
    ep_updateEF(questionID: $questionID, data: $data) {
      sentForReview
    }
  }
`;
export function useUpdateEFMutation(options) {
    const handleMutationCompleted = useHandleMutationCompleted();
    return useGQLMutation(UPDATE_EF_MUTATION, {
        ...options,
        refetchQueries(result) {
            if (!result.data?.ep_updateEF.sentForReview) {
                return [EP_QUESTION_DETAILS_QUERY];
            }
            return [];
        },
        onCompleted(data) {
            handleMutationCompleted(data.ep_updateEF);
        },
    });
}
